import { render, staticRenderFns } from "./TableDraftsSms.vue?vue&type=template&id=691913fc&scoped=true&"
import script from "./TableDraftsSms.vue?vue&type=script&lang=js&"
export * from "./TableDraftsSms.vue?vue&type=script&lang=js&"
import style0 from "./TableDraftsSms.vue?vue&type=style&index=0&id=691913fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691913fc",
  null
  
)

export default component.exports